import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = 20;
export const limitInitialState = initialState;

const limitSlice = createSlice({
  name: 'limit',
  initialState,
  reducers: {
    setLimit(_, action: PayloadAction<number>) {
      return action.payload;
    },
  },
});

export const { setLimit } = limitSlice.actions;
export const { reducer: limitReducer } = limitSlice;
